const variableNames = {
  BLOCKQUOTE: 'blockquote',
  BLOCK_BACKGROUND: 'background',
  BLOCK_DIVIDER: 'block_divider',
  BORDER: 'border',
  CONTACT_ICON: 'contact_icon',
  DECORATION_BACKGROUND: 'decoration_background',
  FEATURE_ICON: 'feature_icon',
  FOOTER_NAV_LINK_TEXT: 'footer_link_text',
  HEADER_PHONE: 'header_phone',
  HEADING_1: 'heading_1',
  HEADING_2: 'heading_2',
  HEADING_3: 'heading_3',
  HEADING_4: 'heading_4',
  HEADING_5: 'heading_5',
  HEADING_6: 'heading_6',
  INPUT_BORDER: 'input_border',
  INPUT_LABEL: 'form_label',
  INPUT_TEXT: 'form_input_text',
  LINK_TEXT: 'link_text',
  MARK_TEXT: 'mark_text',
  NAV_LINK: 'm_nav_link',
  NAV_LINK_ACTIVE: 'm_nav_link_active',
  OVERLAY_BACKGROUND: 'overlay_background',
  PARAGRAPH: 'paragraph',
  SITE_NAME: 'site_name',
  SOCIAL_ICON: 'social_icon',
};

export const variableVariants = {
  [variableNames.BLOCK_BACKGROUND]: {
    GRADIENT: 'background_gradient',
  },
  [variableNames.FOOTER_NAV_LINK_TEXT]: {
    HOVER: 'footer_link_hover_text',
  },
  [variableNames.INPUT_BORDER]: {
    DISABLED: 'input_disabled_border',
    CHECKBOX_BORDER: 'form_checkbox_border',
    DISABLED_CHECKBOX_BORDER: 'form_checkbox_disabled_border',
  },
  [variableNames.LINK_TEXT]: {
    HOVER: 'link_hover_text',
  },
  [variableNames.NAV_LINK]: {
    HOVER: 'm_nav_link_hover',
  },
  [variableNames.SOCIAL_ICON]: {
    HOVER: 'social_icon_hover',
  },
};

export const variablePatterns = {
  PRIMARY_BUTTON_BACKGROUND: /^primary_button_\d+_background$/,
  PRIMARY_BUTTON_BORDER: /^primary_button_\d+_border$/,
  PRIMARY_BUTTON_TEXT: /^primary_button_\d+_text$/,
  SECONDARY_BUTTON_BACKGROUND: /^secondary_button_\d+_background$/,
  SECONDARY_BUTTON_BORDER: /^secondary_button_\d+_border$/,
  SECONDARY_BUTTON_TEXT: /^secondary_button_\d+_text$/,
  PRIMARY_BUTTON_VARIABLE: /primary_button_\d+/,
  SECONDARY_BUTTON_VARIABLE: /secondary_button_\d+/,
};

export default variableNames;
